import { extendTheme } from '@chakra-ui/react';
import { brandColours } from '../../business-emissions/CarbonClickTheme/CarbonClick.Theme';
import { MerchantConfig } from '../configs/merchantConfigs';
import { Button } from './components/Button';

export const createThemeByConfig = (merchantConfig: MerchantConfig) => {
  const { styles } = merchantConfig;
  const { colorPrimary, pageBackground } = styles;
  const borderColour = '#979797';

  const defaultInput = {
    baseStyle: {},
    sizes: {
      lg: {
        field: { fontSize: 'lg', px: 4, h: '56px', borderRadius: '4px' },
        addon: { fontSize: 'lg', px: 4, h: '56px', borderRadius: '4px' },
      },
    },
    variants: {
      outline: {
        field: {
          border: 'solid 1px',
          borderColor: 'brand.midgrey2',
          borderRadius: '4px',
          alignItems: 'center',
          ':focus-within': {
            borderColor: 'blue.500', // the default Chakra UI focus ring colour
            boxShadow: 'var(--chakra-shadows-outline)',
          },
          _hover: {
            borderColor: 'brand.midgrey2',
          },
        },
      },
    },
  };
  const defaultMultiChoice = {
    baseStyle: {
      control: {
        borderColor: borderColour,
      },
    },
  };
  return extendTheme({
    fonts: {
      body: 'Open Sans',
      html: 'Open Sans',
      heading: 'Open Sans',
    },
    colors: { brand: { ...brandColours, ...styles } },
    styles: {
      global: {
        'html, body': {
          bgColor: pageBackground,
        },
        a: {
          color: 'black',
          fontWeight: 'bold',

          _hover: { color: 'black' },
          _selected: { color: 'black' },
          _active: { color: 'black' },
        },
      },
    },
    // https://github.com/chakra-ui/chakra-ui/tree/main/packages/theme/src/components
    components: {
      Tabs: {
        defaultProps: { size: 'lg' },
        variants: {
          line: {
            tab: {
              borderBottom: '5px solid transparent',
              mb: '-2px',
              _selected: { borderBottom: `5px solid ${colorPrimary}` },
            },
          },
        },
      },
      Form: { baseStyle: { helperText: { color: 'black' } } },
      Button: Button,
      Checkbox: defaultMultiChoice,
      Radio: defaultMultiChoice,
      NumberInput: defaultInput,
      Input: defaultInput,
      Select: defaultInput,
      Link: { baseStyle: { textDecoration: 'underline' } },
      FormLabel: {
        baseStyle: {
          fontWeight: 'bold',
        },
      },
    },

    space: {
      defaultSpace: '1.5rem',
    },
  });
};
